export const buildVersion = {
  version: '1.1',
  buildNumber: 294,
  commit: '9300cda38',
};
